import { FETCH_BILLING_SUCCESS } from '../modules/billing';

const translateBillingResponse = store => next => action => {
  // we only want to translation the fetch user success action payload
  if (action.type !== FETCH_BILLING_SUCCESS) {
    return next(action);
  }
  const { customer } = action.payload;

  // If nothing was returned, do not continue with shaping data
  if (!customer) {
    throw new Error('Get billing history returned no data');
  }

  const { lastModifiedDate, lastDueDate, transactionHistory, totalAmountDue } = customer;
  const transactionHistoryList = [];
  let lastInvoiceKey = '';
  let lastInvoiceDate = '';

  // If there wasn't a node returned, we don't want this to error
  if (transactionHistory && transactionHistory.edges && transactionHistory.edges.length > 0) {
    transactionHistory.edges.forEach(edge => {
      transactionHistoryList.push(edge.node);
    });
  }

  if (transactionHistoryList.length > 0 && transactionHistoryList.some(item => item.invoiceKey)) {
    const lastInvoice = transactionHistoryList.filter(item => item.invoiceKey).reduce((a, b) => (a.date > b.date ? a : b));
    lastInvoiceKey = lastInvoice.invoiceKey;
    lastInvoiceDate = lastInvoice.date;
  }

  const newAction = {
    type: action.type,
    payload: {
      lastModifiedDate,
      lastInvoiceKey,
      lastInvoiceDate,
      lastDueDate,
      totalAmountDue: Number(totalAmountDue), // make sure this is a number, not a string
      transactionHistory: transactionHistoryList,
    },
  };
  return next(newAction);
};

export default translateBillingResponse;
